<template>
<div class="forecast-cell">
  <svg width="200" :height="el_height"  @mouseover="hover = true" @mouseleave="hover = false">
      <g :transform="'translate(' + this.margin.right + ', ' + this.margin.top + ')'">
          <rect :x="xScale(lower)" :width="xScale(upper) - xScale(lower)" :y="0" :height="height" class="estimate-ci"/>
          <rect :y="0" :height="height" :x="xScale(estimate)" width="2" class="estimate-mean"/>
          <text :x="xScale(estimate)" text-anchor="middle" :y="height + 15">{{ estimate | percentage(1) }}</text>
      </g>
  </svg>
  <div class="popup" :style="{left: xScale(estimate) + 'px'}" v-if="!mobile && hover">
      {{ $t("other_forecast") }}: <b>{{ estimate | percentage(1) }}</b><br/>
      {{ $t("other_uncertainty_interval") }}: <b>{{ lower | percentage(1) }} - {{ upper | percentage(1) }}</b>
  </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import { mapState } from 'vuex';

export default {
    props: ["estimate", "upper", "lower"],
    data: function() {
        return {
            margin: {left: 10, right: 10, top: 20, bottom: 20},
            el_height: 55,
            hover: false
        }
    },
    computed: {
        ...mapState(["windowWidth"]),
        mobile() {
            return this.windowWidth < 800;
        },
        width () {
            return 200 - this.margin.left - this.margin.right;
        },
        height () {
            return this.el_height - this.margin.top - this.margin.bottom;
        },
        xScale () {
            return d3.scaleLinear().domain([0, 0.5]).range([0, this.width]);
        }
    },
}
</script>

<style scoped>
.estimate-ci {
    fill: var(--blue-dark);
}

.estimate-mean {
    fill: var(--black-primary);
}

.forecast-cell {
    position: relative;
}

.popup {
    position: absolute;
    top: 50px;
    background-color: white;
    padding: 1em;
    width: 40ch;
    transform: translate(-20ch,0);
    text-align: center;
    z-index: 1000;
    box-sizing: border-box;
    line-height: 1.5em;
}
</style>